import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import HomeServices from '../components/home-services.svelte'
import HomeFeatured from '../components/home-featured.svelte'
import BigPicture from 'bigpicture'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		let $homeOverviewImg = $('.home-overview-img')
		if ($homeOverviewImg.length) {
			$homeOverviewImg.on('click', function (e) {
				BigPicture({
					el: e.target,
				})
			})
		}
		scrollReveals()
		parallax()
		homeServices()
		homeFeatured()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function homeServices() {
	const $homeServices = $('#homeServices')
	if ($homeServices.length) {
		new HomeServices({
			target: $homeServices[0],
			props: $homeServices.data(),
		})
	}
}

function homeFeatured() {
	const $homeFeatured = $('#homeFeatured')
	if ($homeFeatured.length) {
		new HomeFeatured({
			target: $homeFeatured[0],
			props: $homeFeatured.data(),
		})
	}
}

function scrollReveals() {
	let $homeHero = $('.home-hero')

	if ($homeHero.length) {
		let hero_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-hero',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		hero_tl.fromTo(
			'.home-hero .decor-img svg',
			{
				opacity: 0,
				y: -40,
			},
			{
				delay: 0.25,
				duration: 0.5,
				opacity: .5,
				y: 0,
			}
		)
		hero_tl.fromTo(
			'.home-hero h1',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		hero_tl.fromTo(
			'.home-hero p',
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
	}

	let $homeOverview = $('.home-overview')
	if ($homeOverview.length) {
		let hotl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-overview',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		hotl.fromTo(
			'.home-overview .green-box .green-box-inner-top-left',
			{
				opacity: 0,
				width: 0,
			},
			{
				delay: 0.1,
				duration: 0.25,
				opacity: 1,
				width: '100%',
			}
		),
			hotl.fromTo(
				'.home-overview .green-box .green-box-inner-top-right',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			),
			hotl.fromTo(
				'.home-overview .green-box .green-box-inner-bottom-right',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			),
			hotl.fromTo(
				'.home-overview .green-box .green-box-inner-bottom-left',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			),
			hotl.fromTo(
				'.home-overview .home-overview-img',
				{
					opacity: 0,
					y: 40,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					y: 0,
				}
			),
			hotl.fromTo(
				'.home-overview .content-wrap',
				{
					opacity: 0,
					y: -40,
				},
				{
					delay: 0.1,
					duration: 0.5,
					opacity: 1,
					y: 0,
				}
			),
			hotl.call(drawBoxes, null, 0.5)
		function drawBoxes() {
			let box_tl = gsap.timeline({
				scrollTrigger: {
					trigger: '.home-overview',
					start: 'top center', // when the top of the trigger hits the center of the viewport
					// markers: true,
				},
			})
			let box_tl_2 = gsap.timeline({
				scrollTrigger: {
					trigger: '.home-overview',
					start: 'top center', // when the top of the trigger hits the center of the viewport
					// markers: true,
				},
			})
			let box_tl_3 = gsap.timeline({
				scrollTrigger: {
					trigger: '.home-overview',
					start: 'top center', // when the top of the trigger hits the center of the viewport
					// markers: true,
				},
			})
			box_tl.fromTo(
				'.home-overview .green-box .small-box .small-box-top-right-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			box_tl.fromTo(
				'.home-overview .green-box .small-box .small-box-top-right-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)

			box_tl.fromTo(
				'.home-overview .green-box .small-box .small-box-top-right-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			box_tl.fromTo(
				'.home-overview .green-box .small-box .small-box-top-right-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)

			box_tl_2.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-left-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			box_tl_2.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-left-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			box_tl_2.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-left-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			box_tl_2.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-left-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)

			box_tl_3.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-right-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			box_tl_3.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-right-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			box_tl_3.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-right-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			box_tl_3.fromTo(
				'.home-overview .green-box .small-box .small-box-bottom-right-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		}
	}

	let $homeServices = $('.home-services')
	if ($homeServices.length) {
		let hstl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-services',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		hstl.fromTo(
			'.home-services .home-services-intro',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		hstl.fromTo(
			'.home-services .home-services-wrap',
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
	}

	let $homeNews = $('.home-news')
	if ($homeNews.length) {
		let hntl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-news',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		hntl.fromTo(
			'.home-news-intro',
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		hntl.fromTo(
			'.home-news .side-img-section',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0.1,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		if (!window.matchMedia('(max-width: 768px)').matches) {
			hntl.fromTo(
				'.home-news .home-news-green-box-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hntl.fromTo(
				'.home-news .home-news-green-box-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			hntl.fromTo(
				'.home-news .home-news-green-box-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hntl.fromTo(
				'.home-news .home-news-green-box-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		} else {
			hntl.fromTo(
				'.home-news .home-news-green-box-1',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hntl.fromTo(
				'.home-news .home-news-green-box-3',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			hntl.fromTo(
				'.home-news .home-news-green-box-4',
				{
					opacity: 0,
					width: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hntl.fromTo(
				'.home-news .home-news-green-box-2',
				{
					opacity: 0,
					height: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		}
	}
}

function parallax() {
	let scrollAnimations = []

	let $homeOverview = $('.home-overview')
	if ($homeOverview.length) {
		scrollAnimations.push(
			basicScroll.create({
				elem: $('.home-overview #compass')[0],
				from: 'top-bottom',
				to: 'bottom-top',
				direct: true,
				props: {
					'--ty':
						innerWidth > 600
							? {
									from: '0',
									to: '-150px',
							  }
							: {
									from: '0',
									to: '-75px',
							  },
				},
			}),
			basicScroll.create({
				elem: $('.home-overview #compass_2')[0],
				from: 'top-bottom',
				to: 'bottom-top',
				direct: true,
				props: {
					'--ty2':
						innerWidth > 600
							? {
									from: '0',
									to: '150px',
							  }
							: {
									from: '0',
									to: '75px',
							  },
				},
			}),
			basicScroll.create({
				elem: $('.home-news > svg')[0],
				from: 'top-bottom',
				to: 'bottom-top',
				direct: true,
				props: {
					'--tr':
						innerWidth > 600
							? {
									from: '20deg',
									to: '-92deg',
							  }
							: {
									from: '20deg',
									to: '-92deg',
							  },
				},
			})
		)
	}

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
